<script setup lang="ts">
import TableSlotsTracker from './shift-control/TableSlotsTracker.vue'

defineOptions({
  name: 'DemosSlotsTrackerPage',
})
</script>

<template>
  <TableSlotsTracker />
</template>
